import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "flex-fill pl-1"
}
const _hoisted_4 = {
  key: 1,
  class: "flex-fill pl-1"
}
const _hoisted_5 = { class: "mt-2" }

import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {
    OnlineChatMessageToClientActionDescription
} from "~/cabinet/ts/data/events/ActionDescription";
import BigIconFlexButtonWrapper from "~/cabinet/vue/interface/button/BigIconFlexButtonWrapper.vue";
import BigRadioFlexButton from "~/cabinet/vue/interface/button/BigRadioFlexButton.vue";
import {
    ANSWER_VARIANT_TYPE_DEFAULT, ANSWER_VARIANT_TYPE_FAST_TRAVEL, ANSWER_VARIANT_TYPE_RETURN, ANSWER_VARIANT_TYPES,
    AnswerVariantInterface,
    ONLINE_CHAT_MESSAGE_TO_CLIENT_SEND_ERROR_MESSAGE_AND_WAIT_FOR_VALID_ANSWER_ACTION_ID
} from "~/cabinet/vue/client/events/action/types/Interface";
import MyInputList from "~/cabinet/vue/interface/form/MyInputList.vue";
import AttachmentsConfig from "~/cabinet/vue/interface/AttachmentsConfig.vue";
import CabinetUploadHelper from "~/cabinet/ts/service/CabinetUploadHelper";
import MyFilter from "~/cabinet/vue/interface/filter/MyFilter.vue";
import {
    getActionDescriptionModelType,
    useActionBlockFormProps
} from "~/cabinet/vue/client/events/action/types/useActionBlockForm";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {computed} from "vue";
import OnlineChatMessageFormPinParams
    from "~/cabinet/vue/client/events/action/types/onlineChat/message/OnlineChatMessageFormPinParams.vue";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";
import VirtualOperatorSelector from "~/cabinet/vue/client/online/config/operators/virtual/VirtualOperatorSelector.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import HelpIcon from "~/cabinet/vue/interface/form/HelpIcon.vue";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";


const __default__ = {
    name: "OnlineChatMessageToOperatorForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useActionBlockFormProps<OnlineChatMessageToClientActionDescription>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

let props = __props;

let operatorTypes = computed(() => {
    return props.actionDescription.frontendParams.operatorTypes;
});

const sendErrorMessageAndWaitForValidAnswerActionId = ONLINE_CHAT_MESSAGE_TO_CLIENT_SEND_ERROR_MESSAGE_AND_WAIT_FOR_VALID_ANSWER_ACTION_ID;

let _modelValue = _useModel<getActionDescriptionModelType<OnlineChatMessageToClientActionDescription>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => ({
    text: null,
    unknownAnswerErrorText: null,
    countInDialogStatistic: false,
    operatorLogin: null,
    operatorType: operatorTypes.value.length ? operatorTypes.value[0].value as string : null,
    virtualOperatorId: null,
    answerVariants: [createNewAnswerVariant()],
    markPreviousMessagesAsReaded: false,
    waitingForClientAnswer: false,
    useAnswerVariants: true,
    messageOnValidateError: null,
    messageOnValidateErrorAttachments: [],
    actionOnValidateError: sendErrorMessageAndWaitForValidAnswerActionId,
    saveAnswerAsField: null,
    attachments: [],
    answerFilters: {},
    withFilters: false,
    pinMessage: false,
    unpinOtherMessages: false,
    disableTextInput: false,
    pinMessageForClient: false,
    unpinOtherMessagesForClient: false,
    contentVariants: [{
        text: null,
        attachments: []
    }]
}), model => {
    if (!model.value.answerFilters) {
        model.value.answerFilters = {};
    }
});

let frontendParams = computed(() => {
    return props.actionDescription.frontendParams;
});


const answerTypes = [
    {
        value: false,
        descr: "Произвольный текст",
        extraDescr: "Клиент сам вводит текст ответа"
    },
    {
        value: true,
        descr: "Выбор из вариантов ответа",
        extraDescr: "Клиенту отобразятся кнопки с вариантами ответа"
    }
];

let isAnswerFiltersUsed = computed(() => props.actionDescription.isAnswerFiltersUsed(model.value));

const uploadHelper = new CabinetUploadHelper();

function createNewAnswerVariant(): AnswerVariantInterface {
    return {
        text: null,
        typeId: ANSWER_VARIANT_TYPE_DEFAULT
    }
}

function addContentVariant() {
    model.value.contentVariants.push({
        text: null,
        attachments: []
    });
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "200px",
    model: _unref(model)
  }, {
    default: _withCtx(() => [
      (_unref(operatorTypes).length)
        ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(ElCardHeader, { title: "Отправитель сообщения" }),
              _createVNode(ElCardSection, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(model).operatorType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).operatorType) = $event)),
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operatorTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: item.descr
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_unref(model).operatorType === 'selectedOperator')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "Оператор",
                        prop: "operatorLogin",
                        rules: _unref(requiredRule)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(model).operatorLogin,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).operatorLogin) = $event)),
                            multiple: "",
                            class: "w-100",
                            placeholder: "Выберите оператора"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frontendParams).operators, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  value: item.value,
                                  label: item.descr
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["rules"]))
                    : _createCommentVNode("", true),
                  (_unref(model).operatorType === 'robot')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "Виртуальный оператор (необязательно)",
                        prop: "virtualOperator"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(VirtualOperatorSelector, {
                            "virtual-operators": _unref(props).eventParamsByAuth.getVirtualOperators(),
                            modelValue: _unref(model).virtualOperatorId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).virtualOperatorId) = $event)),
                            "site-id": _unref(props).eventParamsByAuth.authId
                          }, null, 8, ["virtual-operators", "modelValue", "site-id"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(ElCardHeader, {
            title: "Содержимое сообщения",
            class: "sticky",
            style: {"top":"calc(-1 * var(--card-padding-top))"},
            "button-col-span": 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (addContentVariant()))
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode(" Добавить вариант ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model).contentVariants, (contentVariant, key) => {
            return (_openBlock(), _createBlock(ElCardSection, null, {
              default: _withCtx(() => [
                (_unref(model).contentVariants.length > 1)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_1, [
                      _createVNode(MyIconButton, {
                        trash: "",
                        onClick: ($event: any) => (_unref(model).contentVariants.splice(key, 1))
                      }, null, 8, ["onClick"]),
                      _createTextVNode(" Вариант #" + _toDisplayString(key + 1), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  rules: _unref(requiredRule),
                  prop: "text",
                  label: "Текст сообщения",
                  class: "mt-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TextInputWithVariables, {
                      placeholder: "Введите текст сообщения",
                      modelValue: contentVariant.text,
                      "onUpdate:modelValue": ($event: any) => ((contentVariant.text) = $event),
                      "content-variables": _ctx.contentVariables,
                      bbcode: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "content-variables"])
                  ]),
                  _: 2
                }, 1032, ["rules"]),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { class: "transparent-dashed-card" }, {
                      default: _withCtx(() => [
                        _createVNode(AttachmentsConfig, {
                          modelValue: contentVariant.attachments,
                          "onUpdate:modelValue": ($event: any) => ((contentVariant.attachments) = $event),
                          "upload-helper": _unref(uploadHelper)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "upload-helper"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      }),
      (_ctx.isInScheme)
        ? (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(ElCardHeader, null, {
                title: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _unref(model).waitingForClientAnswer,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).waitingForClientAnswer) = $event)),
                    class: "mr-2"
                  }, null, 8, ["modelValue"]),
                  _cache[17] || (_cache[17] = _createTextVNode(" Ожидать ответа посетителя ", -1))
                ]),
                _: 1
              }),
              (_unref(model).waitingForClientAnswer)
                ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(BigIconFlexButtonWrapper, null, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(answerTypes, (type) => {
                                return _createVNode(BigRadioFlexButton, {
                                  key: type.descr,
                                  modelValue: _unref(model).useAnswerVariants,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(model).useAnswerVariants) = $event)),
                                  label: type.value,
                                  descr: type.descr,
                                  "extra-descr": type.extraDescr,
                                  style: {"min-width":"50%"}
                                }, null, 8, ["modelValue", "label", "descr", "extra-descr"])
                              }), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_unref(model).useAnswerVariants)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_card, { class: "transparent-dashed-card" }, {
                              default: _withCtx(() => [
                                _createVNode(ElCardSection, null, {
                                  default: _withCtx(() => [
                                    _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "mb-4" }, "Варианты ответа", -1)),
                                    _createVNode(MyInputList, {
                                      modelValue: _unref(model).answerVariants,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(model).answerVariants) = $event)),
                                      sortable: "",
                                      "remove-last-available": false,
                                      "standart-button": "",
                                      "add-button-text": "Добавить ответ",
                                      "new-item-value-getter": createNewAnswerVariant
                                    }, {
                                      default: _withCtx(({index}) => [
                                        _createElementVNode("div", _hoisted_2, [
                                          _createElementVNode("div", {
                                            style: {"min-width":"200px"},
                                            class: _normalizeClass({
                                                    'flex-fill': _unref(model).answerVariants[index].typeId == _unref(ANSWER_VARIANT_TYPE_RETURN)
                                                })
                                          }, [
                                            _createVNode(_component_el_select, {
                                              modelValue: _unref(model).answerVariants[index].typeId,
                                              "onUpdate:modelValue": ($event: any) => ((_unref(model).answerVariants[index].typeId) = $event)
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ANSWER_VARIANT_TYPES), (type) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    value: type.id,
                                                    label: type.descr,
                                                    disabled: (type.id === _unref(ANSWER_VARIANT_TYPE_RETURN) && !_unref(props).hasPointOfReturn) || (type.id === _unref(ANSWER_VARIANT_TYPE_FAST_TRAVEL) && !(_unref(props).fastTravelBlocks?.length > 0))
                                                  }, null, 8, ["value", "label", "disabled"]))
                                                }), 256))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "onUpdate:modelValue"])
                                          ], 2),
                                          (_unref(model).answerVariants[index].typeId == _unref(ANSWER_VARIANT_TYPE_DEFAULT))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                _createVNode(TextInputWithVariables, {
                                                  modelValue: _unref(model).answerVariants[index].text,
                                                  "onUpdate:modelValue": ($event: any) => ((_unref(model).answerVariants[index].text) = $event),
                                                  "content-variables": _ctx.contentVariables,
                                                  multiline: false,
                                                  class: "lh-0",
                                                  placeholder: "Введите текст ответа"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "content-variables"])
                                              ]))
                                            : (_unref(model).answerVariants[index].typeId == _unref(ANSWER_VARIANT_TYPE_FAST_TRAVEL))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _unref(model).answerVariants[index].fastTravelBlockId,
                                                    "onUpdate:modelValue": ($event: any) => ((_unref(model).answerVariants[index].fastTravelBlockId) = $event),
                                                    placeholder: "Выберите точку для быстрого перехода"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.fastTravelBlocks)
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fastTravelBlocks, (block) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              label: block.pointOfFastTravelDescr,
                                                              value: block.id
                                                            }, null, 8, ["label", "value"]))
                                                          }), 256))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]))
                                              : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_component_el_switch, {
                                    modelValue: _unref(model).disableTextInput,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(model).disableTextInput) = $event)),
                                    class: "mr-2"
                                  }, null, 8, ["modelValue"]),
                                  _cache[20] || (_cache[20] = _createTextVNode(" Блокировать поле для ввода текста ", -1)),
                                  _createVNode(HelpIcon, { class: "ml2" }, {
                                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                      _createTextVNode(" Эта опция доступна только для бота, запущенного в виджете на вашем сайте ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              label: _withCtx(() => [
                                _cache[22] || (_cache[22] = _createTextVNode(" Уведомление об отправке недопустимого ответа ", -1)),
                                _createVNode(HelpIcon, { class: "ml-1" }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createElementVNode("p", null, " Этот текст будет отправлен, если клиент отправит что-то, не предусмотренное вашим сценарием. ", -1),
                                    _createElementVNode("p", null, " Текст отправляется только если не настроена связь с выходом \"Другой ответ\". ", -1),
                                    _createElementVNode("p", null, " По умолчанию дублируется предыдущий отправленный текст. ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(TextInputWithVariables, {
                                  placeholder: _unref(model).text ?? 'Введите текст сообщения',
                                  modelValue: _unref(model).unknownAnswerErrorText,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(model).unknownAnswerErrorText) = $event)),
                                  "min-height": 20,
                                  "content-variables": _ctx.contentVariables,
                                  bbcode: ""
                                }, null, 8, ["placeholder", "modelValue", "content-variables"])
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_form_item, { label: "Фильтры ответа" }, {
                              default: _withCtx(() => [
                                _createVNode(MyFilter, {
                                  modelValue: _unref(model).answerFilters,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(model).answerFilters) = $event)),
                                  "filters-data": _unref(frontendParams).answerFilters,
                                  placeholder: "Добавьте, если требуется проверка ответа на корректность"
                                }, null, 8, ["modelValue", "filters-data"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: `Сохранить ${_unref(isAnswerFiltersUsed) ? 'корректный' : ''} ответ в информацию о клиенте`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _unref(model).saveAnswerAsField,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(model).saveAnswerAsField) = $event)),
                                  clearable: "",
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frontendParams).fields, (field) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: field.name,
                                        value: field.name,
                                        label: field.descr
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            (_unref(isAnswerFiltersUsed))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_el_form_item, { label: "Действие при некорректном ответе:" }, {
                                    default: _withCtx(() => [
                                      _createVNode(BigIconFlexButtonWrapper, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(frontendParams).actionsOnInvalidAnswer, (descr, actionId) => {
                                            return (_openBlock(), _createBlock(BigRadioFlexButton, {
                                              key: descr,
                                              modelValue: _unref(model).actionOnValidateError,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(model).actionOnValidateError) = $event)),
                                              label: actionId,
                                              descr: descr,
                                              style: {"min-width":"50%"}
                                            }, null, 8, ["modelValue", "label", "descr"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_unref(model).actionOnValidateError === _unref(sendErrorMessageAndWaitForValidAnswerActionId))
                                    ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(TextInputWithVariables, {
                                            placeholder: "Введите текст сообщения",
                                            modelValue: _unref(model).messageOnValidateError,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(model).messageOnValidateError) = $event)),
                                            "content-variables": _ctx.contentVariables,
                                            "left-span": 12,
                                            bbcode: ""
                                          }, {
                                            left: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                              _createTextVNode(" Сообщение при неправильном вводе данных ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["modelValue", "content-variables"]),
                                          _createVNode(_component_el_card, { class: "transparent-dashed-card mt-3" }, {
                                            default: _withCtx(() => [
                                              _createVNode(AttachmentsConfig, {
                                                modelValue: _unref(model).messageOnValidateErrorAttachments,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(model).messageOnValidateErrorAttachments) = $event)),
                                                "upload-helper": _unref(uploadHelper)
                                              }, null, 8, ["modelValue", "upload-helper"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(operatorTypes).length > 0)
        ? (_openBlock(), _createBlock(_component_el_card, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(ElCardHeader, { title: "Дополнительные параметры сообщения" }),
              _createVNode(ElCardSection, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_switch, {
                      modelValue: _unref(model).countInDialogStatistic,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(model).countInDialogStatistic) = $event)),
                      class: "mr-2"
                    }, null, 8, ["modelValue"]),
                    _cache[24] || (_cache[24] = _createTextVNode(" Учитывать этот ответ в статистике операторов ", -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_switch, {
                      modelValue: _unref(model).markPreviousMessagesAsReaded,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(model).markPreviousMessagesAsReaded) = $event)),
                      class: "mr-2"
                    }, null, 8, ["modelValue"]),
                    _cache[25] || (_cache[25] = _createTextVNode(" Помечать предыдущие сообщения клиента прочитанными для оператора, от имени которого будет отправлено сообщение ", -1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(OnlineChatMessageFormPinParams, { value: _unref(model) }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})